import React from "react";
import "./Spinners.css";

export function RoundSpinner() {
  return <div className="spinner-round"></div>;
}
